import { Component, Input, computed, signal, input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatCardModule } from '@angular/material/card';
import { TableData } from '../../../models/api.models';
import { GenericTableComponent, TableColumn, TableConfig } from '../generic-table/generic-table.component';
import { ColumnType } from '../../models/filter.models';

@Component({
  selector: 'app-data-table',
  standalone: true,
  imports: [
    CommonModule,
    MatCardModule,
    GenericTableComponent
  ],
  templateUrl: './data-table.component.html',
  styleUrls: ['./data-table.component.scss']
})
export class DataTableComponent {
  @Input() set tableData(value: TableData | null) {
    this._tableData.set(value);
  }
  @Input() isLoading = false;
  @Input() title = '';
  
  // Use input signal for config
  config = input<Partial<TableConfig>>();

  private _tableData = signal<TableData | null>(null);

  // Convert TableData to format expected by generic-table
  columns = computed<TableColumn[]>(() => {
    const data = this._tableData();
    if (!data?.headers) return [];
    
    return data.headers.map(header => ({
      key: header,
      header: header,
      sortable: true,
      filterable: true,
      type: this.inferColumnType(data.rows, header)
    }));
  });

  tableRows = computed<any[]>(() => {
    const data = this._tableData();
    if (!data?.rows || !data?.headers) return [];
    
    const rows = data.rows.map(row => {
      const obj: any = {};
      data.headers.forEach((header, index) => {
        obj[header] = row[index];
      });
      return obj;
    });
    console.log('DataTable - tableRows computed:', rows);
    console.log('DataTable - columns:', this.columns());
    return rows;
  });

  private defaultConfig: TableConfig = {
    enablePagination: true,
    enableSort: true,
    enableSearch: true,
    enableFilter: true,
    enableCSVDownload: true,
    enableExcelDownload: true,
    showSerialNumber: false,
    stickyHeader: true,
    pageSize: 10,
    pageSizeOptions: [5, 10, 25, 50, 100],
    enableRowSelection: false,
    multipleSelection: false
  };

  tableConfig = computed<TableConfig>(() => ({
    ...this.defaultConfig,
    ...this.config()
  }));

  private inferColumnType(rows: (string | number)[][], header: string): ColumnType {
    const data = this._tableData();
    if (!data?.headers) return ColumnType.String;
    
    const headerIndex = data.headers.indexOf(header);
    if (headerIndex === -1) return ColumnType.String;
    
    // Sample first few non-null values to infer type
    for (let i = 0; i < Math.min(5, rows.length); i++) {
      const value = rows[i][headerIndex];
      if (value === null || value === undefined) continue;
      
      if (typeof value === 'number') {
        return ColumnType.Number;
      }
      if (typeof value === 'boolean') {
        return ColumnType.Boolean;
      }
      // Check if string looks like a date
      // if (typeof value === 'string' && !isNaN(Date.parse(value))) {
      //   return ColumnType.Date;
      // }
    }
    
    return ColumnType.String;
  }
}
